import { requestJson } from '../common/http';
import type { WorkItem } from '../common/models';

export const searchWorkItems = async (query: string): Promise<WorkItem[]> => {
    const response = await requestJson<{ items: WorkItem[] }>({
        method: 'GET',
        path: '/ado/work-items',
        query: { queryType: 'ByTitle', q: query.trim() },
    });
    return response.items;
};

// The member's items for the month's iteration — the default suggestions the
// backfill dialog and the day dialog's quick-add both open with.
export const listParticipationWorkItems = async (teamMemberId: string, year: number, month: number): Promise<WorkItem[]> => {
    const response = await requestJson<{ items: WorkItem[] }>({
        method: 'GET',
        path: '/ado/work-items',
        query: { queryType: 'ByParticipation', teamMemberId, year, month },
    });
    return response.items;
};
